import React, { useEffect } from "react";
import "./MobileTabBar.scss";

export const tabBadge = (count) => (count > 99 ? "99+" : String(count));

export const BottomSheet = ({ title, onClose, children, className = "" }) => {
  useEffect(() => {
    const onKey = (event) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.classList.add("mobile-sheet-open");
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.classList.remove("mobile-sheet-open");
    };
  }, [onClose]);

  return (
    <div className={`mobile-sheet ${className}`}>
      <button type="button" className="mobile-sheet__scrim" aria-label="Close" onClick={onClose} />
      <section className="mobile-sheet__panel" role="dialog" aria-modal="true" aria-label={title}>
        <span className="mobile-sheet__grab" aria-hidden="true" />
        <header className="mobile-sheet__head">
          <h2 className="mobile-sheet__title">{title}</h2>
          <button type="button" className="mobile-sheet__close" onClick={onClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
            </svg>
          </button>
        </header>
        <div className="mobile-sheet__body">{children}</div>
      </section>
    </div>
  );
};

const MobileTabBar = ({ items = [], tone = "tenant", label = "Main" }) => {
  if (!items.length) return null;

  return (
    <nav className={`mobile-tab-bar is-${tone}`} aria-label={label}>
      <ul className="mobile-tab-bar__list">
        {items.map((item) => {
          const Icon = item.icon;
          const active = Boolean(item.isActive);
          return (
            <li key={item.key} className={`mobile-tab-bar__slot${item.primary ? " is-primary" : ""}`}>
              <button
                type="button"
                className={`mobile-tab-bar__item${active ? " is-active" : ""}${item.primary ? " is-primary" : ""}`}
                aria-current={active ? "page" : undefined}
                aria-label={item.badge > 0 ? `${item.label}, ${item.badge} unread` : item.label}
                data-tour={item.tourId}
                onClick={() => {
                  if (active && !item.reopen) return;
                  item.onClick?.();
                }}
              >
                <span className="mobile-tab-bar__icon">
                  {Icon ? <Icon size={item.primary ? 22 : 22} strokeWidth={item.primary ? 2.25 : 1.75} aria-hidden="true" /> : null}
                  {item.badge > 0 ? <span className="mobile-tab-bar__badge">{tabBadge(item.badge)}</span> : null}
                </span>
                <span className="mobile-tab-bar__label">{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileTabBar;
